import React, { useState, useImperativeHandle } from 'react';
import { Alert, Input, Modal, message } from 'antd'; 
import { useCreateTagMutation } from '../../gql/hooks/useCreateTagMutation';
import { Loadable } from '../../../components/loadable/Loadable'; 

const TagCreate = ( { createdTagCallback, ref } ) => {
    const [ tagName, setTagName ] = useState( '' );
    const [ isLoading, setIsLoading ] = useState( '' );
    const [ isModalVisible, setIsModalVisible ] = useState( false );
    const [ invalidName, setInvalidName ] = useState( false );

    const [ createTag ] = useCreateTagMutation();

    useImperativeHandle( ref, () => ( {
        showModal() {
            setTagName( '' );
            setInvalidName( false );
            setIsModalVisible( true );
        }
    } ) );

    /*************************
     * Create the Tag 
     ************************/ 

    const saveNewTag = async () => {
        try {
            const response = await createTag( { variables: { input: { name: tagName } } } );
            const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
            
            if ( success ) {
                setIsLoading( false );
                setIsModalVisible( false );
                if ( createdTagCallback ) {
                    createdTagCallback();
                }
            } else {
                setIsLoading( false );
                setIsModalVisible( false );
                console.error( response ); 
                message.error( 'Error creating tag!' ); 
            }
        } catch ( e ) { 
            setIsLoading( false );
            setIsModalVisible( false );
            console.error( e ); 
            message.error( 'Error creating tag!' );
        }
    };

    /*************************
     * Event handling  
     ************************/ 
    
    const isNameValid = () => {
        const regex = /[a-zA-Z0-9]+/g;
        return regex.exec( tagName ) !== null;
    };

    const handleOkClick = () => {
        if ( isNameValid() ) {
            setInvalidName( false );
            setIsLoading( true );
            saveNewTag( saveNewTag ); 
        } else { 
            setInvalidName( true );
            return false;
        }
    };

    const handleCancelClick = () => { 
        setIsModalVisible( false );
    };

    const handleInputChange = ( e ) => { 
        setTagName( e.currentTarget.value );
    };

    /*************************
     * Render  
     ************************/ 
    
    return (
        <Modal 
            title="Create Tag"
            open={ isModalVisible } 
            onOk={ handleOkClick } 
            destroyOnClose = { true }
            onCancel={ handleCancelClick }
            cancelButtonProps={ { disabled: isLoading } }
            okButtonProps={ { disabled: !( tagName.trim() ) || isLoading } }
        >
            <Loadable loading={ isLoading }>
                <Input
                    autoFocus
                    value={ tagName }
                    placeholder="Tag name"
                    maxLength={ 128 }
                    onChange={ handleInputChange }
                /> 
                { invalidName &&
                    <p>
                        <br/>
                        <Alert message="The tag name must containe one or more alpha numeric characters" type="error" />
                    </p>
                }
            </Loadable>
        </Modal>
    );
};

export default TagCreate;
